import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeTag(request: Boundaries["removeTag"]["request"]): void;
}

function useRemoveTag(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isAssignTagRequestPending),
    isRequestSuccess: useSelector(selector.isAssignTagRequestSuccess),
    isRequestFailure: useSelector(selector.isAssignTagRequestFailure),
    removeTag: core.removeTag,
  };
}

export { useRemoveTag };
